import pegasus from "../../assets/scripts/global/01-pegasus";

document.addEventListener('alpine:init', () => {
    Alpine.data('contextSwitcher', () => ({
        currentContext: null,
        init() {
            this.currentContext = pegasus.getCookie('selectedOption') || 'candidate';

            window.addEventListener('context-switched', (e) => {
                this.currentContext = e.detail.context;
            });
        },

        /**
         * Switch the context of the site
         */
        switchContext(context) {
            this.currentContext = context;
            pegasus.setCookie('selectedOption', context);
            window.dispatchEvent(new CustomEvent('context-switched', { detail: { context: context } }));

            const urlParams = new URLSearchParams(window.location.search);
            urlParams.delete('sitecontext');
            
            // Update the History to remove the siteContext query parameter
            history.pushState({}, null, window.location.pathname);

            document.body.classList.remove('site-candidate');
            document.body.classList.remove('site-client');
            document.body.classList.add('site-' + context);

            window.dispatchEvent(new Event('resize'));
        }
    }))
});
